var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetJournalGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m326 420h-140c-8.284 0-15 6.716-15 15s6.716 15 15 15h140c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.604 311.574-61-260c-1.591-6.781-7.639-11.574-14.604-11.574h-65v-25c0-8.284-6.716-15-15-15h-200c-8.284 0-15 6.716-15 15v25h-65c-6.965 0-13.013 4.793-14.604 11.574l-61 260c-.263 1.123-.396 2.273-.396 3.426v182c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15v-182c0-1.153-.133-2.303-.396-3.426zm-87.492-241.574 53.961 230h-47.073v-85c0-8.284-6.716-15-15-15h-15v-85c0-8.284-6.716-15-15-15h-15v-30zm-53.112 60v70h-230v-70zm30 100v70h-55c-6.456 0-12.188 4.131-14.23 10.257l-16.582 49.743h-118.376l-16.581-49.743c-2.043-6.126-7.775-10.257-14.231-10.257h-55v-70zm-60-200v70h-170v-70zm-253.112 40h53.112v30h-15c-8.284 0-15 6.716-15 15v85h-15c-8.284 0-15 6.716-15 15v85h-47.073zm-57.888 412v-152h125.188l16.581 49.743c2.043 6.126 7.775 10.257 14.231 10.257h140c6.456 0 12.188-4.131 14.23-10.257l16.582-49.743h125.188v152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetJournalGroup);
export default __webpack_public_path__ + "static/media/budget-journal-group.170cde557d8462e31c2c393aa17dd600.svg";
export { ForwardRef as ReactComponent };